module.exports = __webpack_public_path__ + "img/hero_typo_bg.ee348f57.png";